module.exports = __webpack_public_path__ + "static/6-bd88ebe52a0e3539d9867f56f011a817.png";